import { useCallback, useEffect, useRef } from 'react'

export const useDebounceCallback = (
  callback: any,
  delay: number
) => {
  // timeoutRef's job is to store the timeout id
  const timeoutRef = useRef(null)

  // callbackRef's job is to store the callback function to be called in the timeout
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  const debouncedCallback = useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = setTimeout(() => {
        callbackRef.current(...args)
      }, delay)
    },
    [delay]
  )

  useEffect(() => {
    // cleanup
    // When unmounting, clear the timeout
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return debouncedCallback
}



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useDebounceCallback.ts